export default {
  'dynamicEntityGroup.title': 'Manage Dynamic Entities Group',

  'dynamicEntityGroup.form.id': 'ID',
  'dynamicEntityGroup.form.enable': 'Enable',
  'dynamicEntityGroup.form.name': 'Name',
  'dynamicEntityGroup.form.description': 'Description',

  'dynamicEntityGroup.form.statusLabel': 'Enabled Element?',

  'dynamicEntityGroup.enabled': 'Enabled',
  'dynamicEntityGroup.disabled': 'Disabled',

  'dynamicEntityGroup.entities': 'Entities',
};
